export const ALLOCATE_RUNNER_LIST_COLUMN = "ALLOCATE_RUNNER_LIST_COLUMN";